import BuyerDashboard from './BuyerDashboard'
export default BuyerDashboard
